import api from './apiClient';

export type DashboardPeriod = '3m' | '6m' | '1y' | 'all';

export interface KpiBreakdown {
  total: number;
  active: number;
  inactive: number;
}

export interface CompanyBreakdownItem {
  companyId: string;
  companyName: string;
  companyType: string;
  count: number;
}

export interface StatWithBreakdown {
  total: number;
  byCompany: CompanyBreakdownItem[];
}

export interface SuperAdminDashboardData {
  kpis: {
    clientes: KpiBreakdown;
    proveedores: KpiBreakdown;
    usuarios: KpiBreakdown;
  };
  enProceso: {
    fichasServicio: StatWithBreakdown;
    evaluacionesIniciales: StatWithBreakdown;
    permisosTrabajo: StatWithBreakdown;
    accidentesReportados: StatWithBreakdown;
    llamadosAtencion: StatWithBreakdown;
    ticketsSoporte: StatWithBreakdown;
    verificaciones: StatWithBreakdown;
  };
  acumulados: {
    fichasServicio: StatWithBreakdown;
    evaluacionesIniciales: StatWithBreakdown;
    permisosTrabajo: StatWithBreakdown;
    accidentesReportados: StatWithBreakdown;
    llamadosAtencion: StatWithBreakdown;
    ticketsSoporte: StatWithBreakdown;
  };
}

export interface UsersDashboardCompanyRef {
  id: string;
  name: string;
  role: string;
  status: 'active' | 'removed';
}

export interface UsersDashboardRow {
  _id: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  email: string;
  isActive: boolean;
  hasLoggedIn: boolean;
  createdAt?: string;
  globalRole?: string;
  mainCompany: UsersDashboardCompanyRef | null;
  companies: UsersDashboardCompanyRef[];
}

export interface UsersDashboardParams {
  page?: number;
  limit?: number;
  search?: string;
  companyId?: string;
  role?: string;
  active?: 'true' | 'false';
  registered?: 'true' | 'false';
}

export interface UsersDashboardResponse {
  data: UsersDashboardRow[];
  pagination: { total: number; page: number; limit: number; pages: number };
}

export const dashboardApi = {
  getSuperAdmin: async (period: DashboardPeriod = 'all'): Promise<SuperAdminDashboardData> => {
    const res = await api.get('/dashboard/super-admin', { period });
    return res.data;
  },

  getUsersDashboard: async (params: UsersDashboardParams = {}): Promise<UsersDashboardResponse> => {
    const query: Record<string, string> = {};
    if (params.page) query.page = String(params.page);
    if (params.limit) query.limit = String(params.limit);
    if (params.search) query.search = params.search;
    if (params.companyId) query.companyId = params.companyId;
    if (params.role) query.role = params.role;
    if (params.active) query.active = params.active;
    if (params.registered) query.registered = params.registered;
    const res = await api.get('/dashboard/users', query);
    return { data: res.data, pagination: res.pagination };
  },
};
